// firebase setup
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
     apiKey: "AIzaSyBwe5EscAJ6R50s_DSiVFXeIpQPvsEFN2I",
     authDomain: "boredgames-f1375.firebaseapp.com",
     projectId: "boredgames-f1375",
     storageBucket: "boredgames-f1375.appspot.com",
     messagingSenderId: "653304166006",
     appId: "1:653304166006:web:29b94bb66b9d0c36d0d157",
     measurementId: "G-G1CP2X8WNC",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
